import a, { forwardRef as O, useState as T, useMemo as r, useCallback as k, useEffect as w } from "react";
import { TypographyComponent as M } from "../typography/typography-component.esm.js";
import "../typography/typography-config.esm.js";
import { useId as q } from "../utils/hooks/useId.esm.js";
import { useSizeAttrs as D } from "../utils/hooks/useSizeAttrs.esm.js";
import { titleSizeConfig as F } from "./accordion-config.esm.js";
const G = "_accordion_1e911_1", J = "_accordionNoBorder_1e911_16", K = "_accordionClosed_1e911_24", L = "_accordionHeader_1e911_37", P = "_accordionButton_1e911_42", Q = "_accordionHeading_1e911_54", U = "_accordionHeadingInline_1e911_81", V = "_accordionContent_1e911_114", W = "_accordionContentHidden_1e911_118", n = {
  accordion: G,
  accordionNoBorder: J,
  accordionClosed: K,
  accordionHeader: L,
  accordionButton: P,
  accordionHeading: Q,
  accordionHeadingInline: U,
  accordionContent: V,
  accordionContentHidden: W
}, { heading: e } = F, X = O(
  ({
    chevronInline: g = !1,
    children: C = null,
    collapseCallback: s = () => {
    },
    dataTestId: x,
    expandCallback: l = () => {
    },
    heading: H = "",
    headingTag: h = "h3",
    hideBorder: N = !1,
    open: _ = !1,
    className: p,
    titleSize: o = {
      xxs: "xxsmall"
    },
    componentId: d = null,
    ...B
  }, b) => {
    const [c, t] = T(!1), i = q(), f = r(
      () => `fuse-accordion-button-${d || i}`,
      [d, i]
    ), u = r(
      () => `fuse-accordion-content-${d || i}`,
      [d, i]
    ), y = r(
      () => ({
        // Map titleSize viewport sizes to heading typography element viewport sizes i.e. { xxs: 'medium', m: 'large', l: 'xlarge' } to { xxs: '4',  m: '5', l: '6' }
        xxs: e[o.xxs],
        xs: e[o.xs],
        s: e[o.s],
        m: e[o.m],
        l: e[o.l],
        xl: e[o.xl],
        xxl: e[o.xxl]
      }),
      [o]
    ), E = k(
      (m) => {
        c ? (t(!1), s(m)) : (t(!0), l(m));
      },
      [c, s, l]
    );
    w(() => {
      t(!!_);
    }, [_]);
    const I = [
      n.accordion,
      N ? n.accordionNoBorder : "",
      c ? "" : n.accordionClosed,
      p,
      "fuse-accordion"
    ].filter(Boolean).join(" "), j = [n.accordionButton, "fuse-accordion__button"].filter(Boolean).join(" "), A = [
      n.accordionContent,
      c ? "" : n.accordionContentHidden,
      "fuse-accordion__content"
    ].filter(Boolean).join(" "), R = [
      n.accordionHeading,
      g ? n.accordionHeadingInline : "",
      "fuse-accordion__heading"
    ].filter(Boolean).join(" "), $ = h || "h3", v = D(o);
    return /* @__PURE__ */ a.createElement(
      "div",
      {
        className: I,
        "data-testid": x || "fuse-accordion",
        ref: b,
        ...B
      },
      /* @__PURE__ */ a.createElement(
        $,
        {
          className: `${n.accordionHeader} fuse-accordion__header`,
          "data-testid": "fuse-accordion__header",
          ...v
        },
        /* @__PURE__ */ a.createElement(
          "button",
          {
            className: j,
            "data-testid": "fuse-accordion__button",
            "aria-controls": u,
            "aria-expanded": c,
            onClick: E,
            type: "button",
            id: f
          },
          /* @__PURE__ */ a.createElement(
            M,
            {
              className: R,
              "data-testid": "fuse-accordion__heading",
              type: "heading",
              tag: "span",
              size: y
            },
            H
          )
        )
      ),
      /* @__PURE__ */ a.createElement(
        "div",
        {
          className: A,
          "data-testid": "fuse-accordion__content",
          "aria-labelledby": f,
          "aria-hidden": c ? void 0 : !0,
          id: u,
          role: "region"
        },
        C
      )
    );
  }
);
X.displayName = "Accordion";
export {
  X as Accordion
};
